module.exports = __webpack_public_path__ + "static/media/Windows_BN.adff8b31.svg";